export default __webpack_public_path__ + "static/knifeFryingPan-e460575c6fd611775637faff6f834746.png";